// extracted by mini-css-extract-plugin
module.exports = {"container":"TilesWithMain_container__e6Ye8","tiles":"TilesWithMain_tiles__CtmEJ","secondaryTiles":"TilesWithMain_secondaryTiles__iFKnw"};